import { useQuery } from '@tanstack/react-query';

export interface FAQ {
  id: string;
  category: string;
  question: string;
  answer: string;
}

const STATIC_FAQS: FAQ[] = [
  {
    id: '1',
    category: 'Tài khoản',
    question: 'Làm thế nào để đổi mật khẩu?',
    answer: 'Bạn có thể truy cập vào mục Hồ sơ Cá nhân (Profile) từ menu góc trên bên phải, sau đó di chuyển đến phần "Đổi mật khẩu".',
  },
  {
    id: '2',
    category: 'Phân quyền',
    question: 'Tại sao tôi không thấy nút Duyệt Yêu cầu?',
    answer: 'Nút duyệt chỉ hiển thị khi tài khoản của bạn được cấp quyền "approvals.manage". Vui lòng liên hệ Quản trị viên để được cấp quyền.',
  },
  {
    id: '3',
    category: 'Vật tư',
    question: 'Tôi có thể sửa phiếu xuất kho đã duyệt không?',
    answer: 'Không. Các phiếu đã được phê duyệt không thể chỉnh sửa để đảm bảo tính minh bạch. Bạn cần tạo phiếu yêu cầu hủy hoặc lập phiếu xuất mới bổ sung.',
  },
  {
    id: '4',
    category: 'Hệ thống',
    question: 'Làm sao để xóa cache trình duyệt khi web bị lỗi hiển thị?',
    answer: 'Bạn có thể nhấn tổ hợp phím Ctrl + F5 (Windows) hoặc Cmd + Shift + R (Mac) để tải lại trang và xóa cache tạm thời.',
  }
];

export function useFAQs() {
  return useQuery({
    queryKey: ['help_faqs'],
    queryFn: async () => {
      // In production, this would fetch from Supabase:
      // const { data, error } = await supabase.from('faqs').select('*');
      // if (error) throw error;
      // return data;
      
      // Simulating network delay
      await new Promise(resolve => setTimeout(resolve, 500));
      return STATIC_FAQS;
    },
    staleTime: 5 * 60 * 1000,
  });
}
